export enum EmployeeActivitiesBackendAcceptableParams {
	DATE = "DATE",
	EMPLOYEE = "EMPLOYEE",
	TERMINAL = "TERMINAL",
	DESCRIPTION = "DESCRIPTION",
	CONTEXT = "CONTEXT",
	PARAMETERS = "PARAMETERS",
	TYPE = "TYPE",
}
